import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export function GuidedResponsePreviousButton(props) {
	const { isLoading, handler } = props
	const [isClicked, setIsClicked] = useState(false);

	const clicked = (e) => {
		setIsClicked(true);
		handler(e);
	};

	return (
		<button className="btn btn-secondary" type="button" disabled={isLoading} onClick={clicked}>
			{isClicked && isLoading ? <span><FontAwesomeIcon icon="spinner" spin /> Processing...</span> : <span>Previous</span>}
		</button>
	);
}